import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import axios from "axios";
import ReuseableButton from "../../../components/Buttons/button";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { userColumns } from "./doctorColumns";

const departmentUrl = "https://arogyanxtdevapi.fundaclear.in/api/Doctor"

const DoctorList = () => {
    const [loader, setLoader] = useState(false);
    const [doctorList, setDoctorList] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const fetchdoctorListList= () => {
            setLoader(true)
            axios.get(departmentUrl).then((res) => {
                if (res?.status === 200) {
                    setLoader(false)
                    setDoctorList(res?.data?.result)
                }

            }).catch(err => console.log(err))
        }
        fetchdoctorListList()
    }, [])
    const handleRouteBranchInfo = () => {
        navigate("/master/add-doctor")
    }
    const handleGetRowId = (e) => {
        return e?.uniqueId
    }
    return (
        <>
            <div className='d-flex justify-content-end'>
                <div className="mr-5">
                    <ReuseableButton
                        text={"Add Doctor"}
                        height={45}
                        colorVarient="success"
                        fullWidthFlag={true}
                        endIcon={<PersonAddAltIcon />}
                        handleChange={handleRouteBranchInfo}
                    />

                </div>
            </div>
            <div className="branch-table p-2">
                <DataGrid
                    autoHeight
                    rows={doctorList && doctorList?.length > 0 ? doctorList : []}
                    loading={loader ? loader : false}
                    columns={userColumns}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                />
            </div>
        </>
    )
};

export default DoctorList